// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCpTH2NlSEqMJsM2Hgsy5eoHd2JSOmEML0",
  authDomain: "ha-rue.firebaseapp.com",
  projectId: "ha-rue",
  storageBucket: "ha-rue.appspot.com",
  messagingSenderId: "696032396842",
  appId: "1:696032396842:web:89e50ac99633c97b5fe553",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
